import { breakpoints } from '@/css/resources/variables.css';
import { cssObj } from '@/css/resources/functions.css';

const getColumnStart = (start) => (start > 12 ? 1 : start);

const getColumnLeftStyle = (styles) =>
	cssObj({
		gridColumnStart: +styles?.mobile?.offsetLeft + 1,
		gridColumnEnd: `span ${styles?.mobile?.columnLeft}`,
		[`@media (min-width: ${breakpoints.medium})`]: {
			gridColumnStart: +styles?.tablet?.offsetLeft + 1,
			gridColumnEnd: `span ${styles?.tablet?.columnLeft}`,
		},
		[`@media (min-width: ${breakpoints.bigLaptop})`]: {
			gridColumnStart: +styles?.desktop?.offsetLeft + 1,
			gridColumnEnd: `span ${styles?.desktop?.columnLeft}`,
		},
	});

const getColumnRightStyle = (styles) =>
	cssObj({
		gridColumnStart: getColumnStart(
			+styles?.mobile?.offsetLeft +
				+styles?.mobile?.columnLeft +
				+styles?.mobile?.gapBetween +
				1
		),
		gridColumnEnd: `span ${styles?.mobile?.columnRight}`,
		[`@media (min-width: ${breakpoints.medium})`]: {
			gridColumnStart: getColumnStart(
				+styles?.tablet?.offsetLeft +
					+styles?.tablet?.columnLeft +
					+styles?.tablet?.gapBetween +
					1
			),
			gridColumnEnd: `span ${styles?.tablet?.columnRight}`,
		},
		[`@media (min-width: ${breakpoints.bigLaptop})`]: {
			gridColumnStart: getColumnStart(
				+styles?.desktop?.offsetLeft +
					+styles?.desktop?.columnLeft +
					+styles?.desktop?.gapBetween +
					1
			),
			gridColumnEnd: `span ${styles?.desktop?.columnRight}`,
		},
	});

export { getColumnLeftStyle, getColumnRightStyle };
